module.exports = __webpack_public_path__ + "img/send.75bda2cd.svg";